import { render, staticRenderFns } from "./UrgeForm.vue?vue&type=template&id=718b4438"
import script from "./UrgeForm.vue?vue&type=script&lang=js"
export * from "./UrgeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718b4438')) {
      api.createRecord('718b4438', component.options)
    } else {
      api.reload('718b4438', component.options)
    }
    module.hot.accept("./UrgeForm.vue?vue&type=template&id=718b4438", function () {
      api.rerender('718b4438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/task/UrgeForm.vue"
export default component.exports